export const CHATBOT_TABS = [
  'overview',
  'conversations',
  'training',
  'members',
  'configuration',
  'settings',
] as const;

export type ChatbotTabId = (typeof CHATBOT_TABS)[number];

export const DEFAULT_CHATBOT_TAB: ChatbotTabId = 'overview';

export function isChatbotTabId(
  value: string | undefined,
): value is ChatbotTabId {
  return (
    value !== undefined && (CHATBOT_TABS as readonly string[]).includes(value)
  );
}

export function resolveChatbotTabPath(
  chatbotId: string,
  tabId: ChatbotTabId,
): string {
  return `/chatbots/${encodeURIComponent(chatbotId)}/${tabId}`;
}

export function resolveChatbotConversationPath(
  chatbotId: string,
  conversationId: string,
): string {
  return `/chatbots/${encodeURIComponent(chatbotId)}/conversations/${encodeURIComponent(conversationId)}`;
}
